<template>
  <!-- 收入结算 -->
 <div >
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
          <div class="gjhBox">
            <el-form-item label="业务编号:" prop="businessNo">
              <el-input  placeholder=""   type="textarea" v-model="searchFrom.businessNoss" class="gjh"></el-input>
            </el-form-item>
          </div>
            <div class="item">
              <el-form-item label="货主名称:" prop="tenantName">
                <el-input  placeholder="" v-model="searchFrom.tenantName"></el-input>
              </el-form-item>
              <el-form-item label="收款状态:" prop="settlementStatus">
                <el-select  v-model="searchFrom.settlementStatus"   placeholder="请选择">
                   <el-option label="全部" value=""></el-option>
                  <el-option label="待收款" value="1301"></el-option>
                  <el-option label="已收款待确认" value="1302"></el-option>
                  <el-option label="已收款" value="1303"></el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="业务类型" prop="invoiceType">
                  <el-select  v-model="searchFrom.invoiceType"   placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="运输业务" value="1"></el-option>
                    <el-option label="快递业务" value="2"></el-option>
                    <el-option label="找车业务" value="3"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="订单类型" prop="periodFlag">
                  <el-select  v-model="searchFrom.periodFlag"   placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="普通货源" value="0"></el-option>
                    <el-option label="长期货源" value="1"></el-option>
                  </el-select>
                </el-form-item>
              <el-form-item label="收款账户名称:" prop="platformZxAccNm">
                <el-input  placeholder="" v-model="searchFrom.platformZxAccNm"></el-input>
              </el-form-item>
              <el-form-item label="收款账号:" prop="platformZxAccNo">
                <el-input  placeholder="" v-model="searchFrom.platformZxAccNo"></el-input>
              </el-form-item>
              <el-form-item label="开票状态:" prop="invoiceStatus">
                <el-select  v-model="searchFrom.invoiceStatus"   placeholder="请选择">
                   <el-option label="全部" value=""></el-option>
                  <el-option label="未开票" value="0"></el-option>
                  <el-option label="待开票" value="1"></el-option>
                  <el-option label="开票中" value="2"></el-option>
                  <el-option label="已开票" value="3"></el-option>
                  <el-option label="不开票" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收款时间:" prop="settlementTime">
                <el-date-picker
                  v-model="searchFrom.settlementTimes"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
               <el-form-item label="创建时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="是否推送T+:" prop="tPlusId">
                <el-select  v-model="searchFrom.tPlusId" placeholder="请选择">
                  <!-- 0是 1否 -->
                  <el-option label="全部" value=""></el-option>
                  <el-option label="是" value="0"></el-option>
                  <el-option label="否" value="1"></el-option>
                </el-select>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
           <el-form-item btnCode="00JP001B001" v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item btnCode="00JP001B002" v-if="btnFlg[1]">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item btnCode="00JP001B003"  v-if="btnFlg[2]">
            <el-button type="primary" @click="exportFn">导出</el-button>
          </el-form-item>
          <el-form-item  btnCode="00JM010200" v-if="btnFlg[4]">
            <el-button type="primary" @click="tuiSong">推送T+</el-button>
          </el-form-item>
          <el-form-item>
            <div style="display:flex;">
              <p style="width:15px;height:15px;background:#F2E0D7;margin-top: 6px;"></p>
              <span class="red">超期未结算</span>
            </div>
          </el-form-item>
          <el-form-item>
           <p class="margin0">应收合计：<span class="red">{{shouruData.total}}</span>元</p>
          </el-form-item>
          <el-form-item>
           <p class="margin0">已收合计：<span class="red">{{shouruData.alreadytotal}}</span>元</p>
          </el-form-item>
          <el-form-item>
           <p class="margin0">未收合计：<span class="red">{{shouruData.wTotal}}</span>元</p>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" :cell-class-name="myclass" ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作"  width="160">
             <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini"  v-if ="scope.row.settlementStatus == 1303" @click="huidanFn(scope.row)">银行回单</el-button>
                <el-button type="text" size="mini" v-if ="scope.row.settlementStatus == 1302&&btnFlg[3]" @click="xianxiaFn(scope.row)">线下确认</el-button>
              </div>
             </template>
        </el-table-column>
         <el-table-column label="业务编号"  width="200">
            <template slot-scope="scope">
              <span style="color: #0e6eec;cursor: pointer;" v-if="scope.row.invoiceType==1" @click="seeClickNO(scope.row)">{{scope.row.businessNo}}</span>
               <span v-else>{{scope.row.businessNo}}</span>
            </template>
        </el-table-column>
        <el-table-column property="settlementStatus" label="收款状态" width="140">
          <template scope="scope">
            <div>
              <span v-if="scope.row.settlementStatus==1301" style="color:red">待收款</span>
              <span v-if="scope.row.settlementStatus==1302">已收款待确认</span>
              <span v-if="scope.row.settlementStatus==1303">已收款</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="overdueDate" width="120" :formatter="emptyFn" label="超期天数（天）"></el-table-column>
        <el-table-column property="payType" label="支付方式">
         <template scope="scope">
          <div>
            <span v-if="scope.row.payType">{{[ "线上支付","线下支付"][scope.row.payType-1]}}</span>
            <span v-else>-</span>
          </div>
         </template>
        </el-table-column>
        <el-table-column property="invoiceType" label="业务类型" width="100">
          <template scope="scope">{{[ "运输业务","快递业务","找车业务" ][scope.row.invoiceType-1]}}</template>
        </el-table-column>
        <el-table-column property="periodFlag" label="订单类型" width="100">
          <template scope="scope">{{[ "普通货源","长期货源" ][scope.row.periodFlag]}}</template>
        </el-table-column>
        <el-table-column width="320" property="platformZxAccNm"  :formatter="emptyFn" label="收款账户名称"></el-table-column>
        <el-table-column width="200" property="platformZxAccNo"  :formatter="emptyFn" label="收款账号"></el-table-column>
        <el-table-column property="invoiceStatus" label="开票状态">
          <template scope="scope">{{[ "未开票","待开票", "开票中","已开票","不开票"][scope.row.invoiceStatus]}}</template>
        </el-table-column>
        <el-table-column property="tenantName"  width="270"  :formatter="emptyFn" label="货主名称"></el-table-column>
        <el-table-column property="weight"  width="120"  :formatter="emptyFn" label="结算量"></el-table-column>
         <el-table-column property="publishPricingMethod" label="计价方式">
          <template scope="scope">{{[ "单价", "包干",][scope.row.pricingMethod-1]}}</template>
        </el-table-column>
        <el-table-column property="unitPrice" width="100"     label="单价">
          <template scope="scope">
            <div>
            <span v-if="scope.row.pricingMethod==1">{{scope.row.unitPrice}}元/{{scope.row.unitMeasurement}}</span>
            <span v-if="scope.row.pricingMethod==2">-</span>
            </div>
          </template>
        </el-table-column>
        <!-- 过段时间再打开 -->
        <!-- <el-table-column property="rate" label="服务费率">
             <template scope="scope">{{accMul(scope.row.rate,100)}}%</template>
        </el-table-column> -->
        <el-table-column label="应收合计(元)"  width="120">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.invoiceType==3">{{scope.row.totalAmount}}</span>
                 <el-button v-else
                type="text"
                size="mini"
                @click="YFHJfn(scope.row)"
               style="font-size:14px;">{{scope.row.totalAmount}}</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column property="tPlusId" label="是否推送T+" width="120">
          <template scope="scope">
             <div>
              <!-- tPlusId有值已推送  null未推送 -->
              <span v-if="scope.row.tPlusId">是</span>
              <span v-else>否</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="170" property="settlementTime"  :formatter="dateFormat" label="收款时间"></el-table-column>
        <el-table-column width="170" property="createTime" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
   <!-- 应付合计 -->
    <el-dialog  title="应收合计"  :visible.sync="HJmark" width="600px" class="detail"   :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div>
        <div class="addressBox" >
             <div>
          <p>应付合计:<span style="color:red;font-size:18px">{{searchFrom.totalAmount}}</span>元</p>
        </div></div>
        <div class="table">
            <el-table :data="hejiList"  ref="hejiList" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'  style="width: 100%" center border>
              <el-table-column property="publishPricingMethod" label="费目">
                             <template scope="scope">{{[ "运费", "服务费","押金"][scope.row.feeType-1]}}</template>
              </el-table-column>
              <el-table-column property="publishPricingMethod" label="状态">
                <template scope="scope">{{[ "待收款", "已收款",][scope.row.feeStatus-1]}}</template>
              </el-table-column>
              <el-table-column property="amount"  width="120"  :formatter="emptyFn"   label="金额(元)"></el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button  type="primary" @click="HJmark = false">关闭</el-button>
      </span>
   </el-dialog>
    <!-- 订单详情 -->
    <orderDetail :rowData="row"  v-if="orderDetilFlag"  @destroy="destroy"></orderDetail>
    <!-- 线下支付 -->
    <offlinePayment :rowData="row"  v-if="offlineFlag"  @destroy="destroy"></offlinePayment>
    <!-- 推送T+ -->
   <el-dialog title="推送T+" v-loading="tuiSongLoading" :visible.sync="tuiSongTMark" width="600px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div class="table">
        <el-form ref="tuiSongForm" :inline="true" size="mini" class="demo-form-inline">
          <el-form-item label="账套名称:" style="margin-left:110px;width:380px;padding:20px 0 100px 0;">
            <el-select v-model="tuiSongForm.itemNo" clearable filterable placeholder="请选择" style="width:260px" size="mini">
              <el-option v-for="(item, index) in dicDataTms" :key="index" :label="item.showName" :value="item.itemNo">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tuiSongQuXiao" >取消</el-button>
        <el-button type="primary" @click="tuiSongSubmit">确定</el-button>
      </span>
   </el-dialog>
 </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, accMul } from '@/utils/util'
import orderDetail from '@/views/consignment/payCustomer/settlement/orderDetail.vue'
import offlinePayment from '@/views/consignment/payCustomer/settlement/offlinePayment.vue'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import {
  settlementList, // 列表
  // ownerBalanceAdd, // 结算运费
  upstreamsettlementDetailList, // 应收合计
  bankReceipt // 银行回单
} from '@/api/consignment'
import { getDicFromTms, pushTPlusToTmsCollection } from '@/api/common-signature'
import { chaKanHuiDan } from '@/utils/chaKanHuiDan'
export default {
  components: {
    orderDetail,
    offlinePayment
  },
  data () {
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      accMul: accMul,
      h: '500px',
      // 查询
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: 'false',
      total: 0,
      // 订单详情
      orderDetilFlag: false,
      row: {},
      // 合计
      HJmark: false,
      hejiList: [],
      shouruData: {},
      rules: {
        reason: { required: true, message: '请输入拒绝原因', trigger: 'blur' }
      },
      offlineFlag: false, // 线下支付
      btnFlg: [],
      btnIdArr: ['00JP001B001', '00JP001B002', '00JP001B003', '00JM010100', '00JM010200'],
      tuiSongTMark: false,
      tuiSongForm: {},
      dicDataTms: [],
      upstreamSettlementList: [],
      tuiSongLoading: false,
      selectIds: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/payPlatform/customer')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    // 修改单元格样式的方法
    myclass ({ row, column, rowIndex, columnIndex }) {
      if (column.label == '收款状态') {
        if (row.isOverdue == '1') {
          return 'setclass'
        }
      }
    },
    // 线下支付
    xianxiaFn (row) {
      this.row = row
      this.row.flag = 2// 代表是平台端
      this.offlineFlag = true
    },
    // 银行回单
    huidanFn (row) {
      chaKanHuiDan(row.businessNo, '', 2)
      // bankReceipt({ platformZxAccNo: row.platformZxAccNo, businessNo: row.businessNo }).then(res => {
      //   let url = this.global.ZXpingzheng + 'subAccNo=' + res.platformZxAccNo + '&printVerifyCode=' + res.printVerifyCode
      //   window.open(url)
      // }).catch(error => {
      //   this.$message({
      //     showClose: true,
      //     message: error.message,
      //     type: 'error',
      //     onClose () {
      //     }
      //   })
      // })
    },
    // 导出
    exportFn () {
      let form = this.searchFrom
      exportExcel(
        this.global.payServer + '/upstreamSettlement/exportList',
        form,
        '收入结算列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 记录
    jiluFn (row) {
      this.jiluMark = true
    },
    // 调价
    tiaojiaFn (row) {
      this.tiaojiaMark = true
    },
    // 应付合计
    YFHJfn (row) {
      this.HJmark = true
      upstreamsettlementDetailList({ businessNo: row.businessNo }).then(res => {
        this.hejiList = res.list
        this.searchFrom.totalAmount = row.totalAmount
      })
    },

    // 申请开票
    SQKPfn () {
      this.$router.push({ path: '/payCustomer/invoiceApply' })
    },
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 订单详情
    seeClickNO (row) {
      this.row = row
      this.orderDetilFlag = true
    },
    destroy () {
      this.orderDetilFlag = false
      this.offlineFlag = false
    },
    // 查选
    searchFn () {
      if (this.searchFrom.businessNoss) { this.searchFrom.businessNos = this.searchFrom.businessNoss.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.businessNos = ''
      }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      settlementList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        this.shouruData.total = res.map.allTotal
        this.shouruData.wTotal = res.map.wTotal
        this.shouruData.alreadytotal = res.map.alreadytotal
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },
    // 重置
    resetForm (formName) {
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        carriageType: 1,
        type: 2,
        receiveStatus: 1,
        appointType: 1
      }
    },
    closeDialog () {
      this.addForm = {}
      this.CHFrom = {}
    },
    // 点击推送T+
    tuiSong () {
      const selectData = this.$refs.table.selection
      console.log(selectData, 'selectData')
      // 必须是已收款settlementStatus = 1303 并且收款账号、货主名称、收款时间、未推送
      let platformZxAccNoArr = [] // 收款账号
      let tenantNameArr = [] // 货主名称
      let settlementStatusArr = [] // 收款状态
      let tPlusIdArr = [] // 是否推送
      let settlementTimeArr = [] // 收款时间
      selectData.forEach((item, index) => {
        platformZxAccNoArr.push(item.platformZxAccNo)
        tenantNameArr.push(item.tenantName)
        settlementStatusArr.push(item.settlementStatus)
        tPlusIdArr.push(item.tPlusId)
        settlementTimeArr.push(this.timeStamp(item.settlementTime))
      })
      // console.log(settlementTimeArr,'settlementTimeArr')
      let flagA = settlementStatusArr.every(item => item == 1303)
      let flagB = tPlusIdArr.every(item => item == null)
      console.log(flagB, 'flagB')
      // tPlusId有值已推送  null未推送
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (!flagA) {
        this.$alert('只能选择已收款的数据', '系统提示')
      }
      // 2023年2月23日改，财务提需求：可以重复推送T+
      // else if (!flagB) {
      //   this.$alert('只能选择未推送的数据', '系统提示')
      // }
      else if (!this.isAllEqual(tenantNameArr)) {
        this.$alert('货主名称必须一致', '系统提示')
      } else if (!this.isAllEqual(platformZxAccNoArr)) {
        this.$alert('收款账号必须一致', '系统提示')
      } else if (!this.isAllEqual(settlementTimeArr)) {
        this.$alert('只能选择同一天收款数据', '系统提示')
      } else if (selectData.length > 100) {
        this.$alert('最多只能选择100条数据进行操作', '系统提示')
      } else {
        this.tuiSongTMark = true
        this.getDicFromTms()
        this.upstreamSettlementList = selectData
      }
    },
    tuiSongSubmit () {
      this.tuiSongLoading = true
      this.selectIds = []
      this.upstreamSettlementList.forEach((item, index) => {
        this.selectIds.push(item.id)
      })
      pushTPlusToTmsCollection({
        itemNo: this.tuiSongForm.itemNo, // （取“getDicFromTms”接口返回的itemNo对应的值）
        upstreamSettlementList: this.selectIds.toString() // 上游结算单对象
      }).then(res => {
        this.tuiSongLoading = false
        this.$message.success('成功')
        this.tuiSongTMark = false
        this.getList(this.searchFrom)
        this.tuiSongForm.itemNo = ''
      }).catch(error => {
        this.tuiSongLoading = false
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error'
        })
      })
    },
    tuiSongQuXiao () {
      this.tuiSongTMark = false
      this.tuiSongForm.itemNo = ''
    },
    getDicFromTms () {
      getDicFromTms({
        dictionaryType: 'yongyou_push_t'
      }).then(res => {
        // console.log(res, 'res')
        this.dicDataTms = res
      })
    },
    isAllEqual (array) {
      if (array.length > 0) {
        return !array.some(function (value, index) {
          return value !== array[0]
        })
      } else {
        return true
      }
    },
    timeStamp (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log("time:" + JSON.stringify(now));
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
    width: 350px!important;
}
/deep/.setclass{
  background: #F2E0D7;
}
</style>
